import Vue from 'vue'
import Vuex from 'vuex'
//  *********************
// 动态路由及权限加载
//  *********************

import getters from './getters'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)
const modulesFiles = require.context(`./modules`, true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    // set './app.js' => 'app'
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, `$1`)
    const value = modulesFiles(modulePath)
    modules[moduleName] = value.default
    return modules
}, {})

const state = {
    screenHeight: null,
    screenWidth: null,
    containerWidth: 0,
    currentUser: null,
    otherSettingColumn: [],
    extendColumnList: [],
    currentWorker: null,
    currentSurgery: null,
    username: `演示人`,
    workbar: [],
    menus: [],
    hospital_ward: [], // 院区
    operation_ward: [], //  手术区
    operation_room: [],
    recovery_ward: [], // 复苏区
    recovery_bed: [],
    section: [], //  科室
    hospital_ward_auth: [], //  经过数据权限筛选的院区
    operation_ward_auth: [], //  经过数据权限筛选的手术区
    operation_room_auth: [],
    recovery_ward_auth: [], // 经过数据权限筛选的复苏区
    recovery_bed_auth: [],
    section_auth: [], //  科室
    inpatient_section_auth: [], //  病区
    ward_auth: [], // 区域
    routers: [],
    add_work_bar_ing: false,
    get_menu_ing: false,
    active_ward: ``,
    active_hospital_ward: ``,
    business: [],
    sys_document_list: [],
    sys_document: {},
    languages: [],
    userConfigs: []
}

const store = new Vuex.Store({
    modules,
    getters,
    state,
    mutations,
    actions
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js